// import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';


const ProviderTooltip = withStyles({
  tooltip: {
    fontSize: 15,
  }
})(Tooltip);

export default ProviderTooltip;
